import { render } from "./AfterPayment.vue?vue&type=template&id=2c025018&scoped=true"
import script from "./AfterPayment.vue?vue&type=script&lang=js"
export * from "./AfterPayment.vue?vue&type=script&lang=js"

import "./AfterPayment.vue?vue&type=style&index=0&id=2c025018&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c025018"]])

export default __exports__